(function(angular){
	'use strict';
	
	var hbiCTAObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {},
		controller: [
			'$window',
			'addToWaitlistFactory',
			'APP_BASE_PATH',
			CtaFunction
		],
		controllerAs: 'cta'
	};
	
	angular
		.module('hbiModule')
		.component('cta', hbiCTAObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/hbi/cta.html';
	}
	
	function CtaFunction(
		$window,
		addToWaitlistFactory,
		APP_BASE_PATH
	) {
		var cta = this;

		cta.emailSubmit = function () {
			if(cta.email) {
				cta.submitted = true;
				
				addToWaitlistFactory.addToWaitlist(cta.email).then(function(){
					redirectAfterWaitlistAdd();
				}, function(){
					redirectAfterWaitlistAdd();
				});
			}
		};

		function redirectAfterWaitlistAdd(){
			$window.location.href = APP_BASE_PATH + '/start-investing';
		}

		cta.$onInit = function() {
			cta.submitted = false;
		};
	}
})(window.angular);